import React from 'react';
import { useTranslate } from '../../contexts/languageContext';
import styled from 'styled-components/macro';

const EstadisticasConsolidadoTabla_Cabecera = props => {
  const t = useTranslate();
  return (
    <>
      <tr className="subHeader">
        <th colSpan='4'>
          {t('consolidado') + ' ' + props.data.nombre}
        </th>
      </tr>

      <FilaAños>
        <Año />
        <Año>2022</Año>
        <Año>2018</Año>
        <Año>2014</Año>
      </FilaAños>
    </>
  );
};

const FilaAños = styled.tr`
  display: flex;
  justify-content: space-between;
  width: 98%;
  border-bottom: 1px solid #dadada;
`;
const Año = styled.th`
  width: 33%;
  text-align: right;
`;

export default EstadisticasConsolidadoTabla_Cabecera;
